import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Button } from '@mui/material';
import React from 'react';
import Popover from './Popover';
import { useGetAllNotifications } from '../../services/react-query/notifications/useGetAllNotifications';
import _ from 'lodash';

export default function Notifications() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const { data: notifications = [] } = useGetAllNotifications({ enabled: true });

  // filter out seen notifications
  const unseenNotifications = _.reject(notifications, 'seen_at');
  const unseenNotificationsCount = unseenNotifications.length;

  const openPopover = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button sx={{ width: 'auto' }} onClick={openPopover}>
        <Badge badgeContent={unseenNotificationsCount} color="error" invisible={unseenNotificationsCount === 0}>
          <NotificationsIcon sx={{ color: 'var(--paper)' }} />
        </Badge>
      </Button>
      <Popover
        anchorEl={anchorEl}
        onClose={closePopover}
        open={!!anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      />
    </>
  );
}
